import PropTypes from 'prop-types';

import { toThousandsSeparator, toUSD } from 'helpers/NumberFormats';
import css from 'styles/components/checkout/melody/shippingOption/shippingDowngradeDetails.scss';

export const ShippingDowngradeDetails = ({ promise, title, downgradeEstimateDollars, downgradeEstimatePoints }, { testId }) => (
  <div className={css.wrapper} data-test-id={testId('shippingDowngradeDetails')}>
    <span className={css.rewardsStars} />
    <p className={css.title}>{title}</p>
    <p>With <b>{promise} Shipping</b> selected, you will receive {toUSD(downgradeEstimateDollars)} worth of Zappos Rewards Points ({toThousandsSeparator(downgradeEstimatePoints)} points) which can be used toward future purchases.</p>
  </div>
);

ShippingDowngradeDetails.contextTypes = {
  testId: PropTypes.func
};

export default ShippingDowngradeDetails;
